import type { DatabricksRawProtocolClient } from "./raw-protocol-client.js";

export interface DatabricksSqlWarehouse {
  id: string;
  name?: string;
  state?: string;
}

/** Discover SQL warehouses through the reviewed SDK-gap protocol. */
export async function listDatabricksSqlWarehouses(
  client: DatabricksRawProtocolClient,
): Promise<DatabricksSqlWarehouse[]> {
  const payload = await client.get<{
    warehouses?: Array<{ id?: string; name?: string; state?: string }>;
  }>("/api/2.0/sql/warehouses");
  return (payload.warehouses ?? [])
    .filter((warehouse): warehouse is { id: string; name?: string; state?: string } =>
      Boolean(warehouse.id),
    )
    .map((warehouse) => ({
      id: warehouse.id,
      ...(warehouse.name ? { name: warehouse.name } : {}),
      ...(warehouse.state ? { state: warehouse.state } : {}),
    }));
}

export function chooseDatabricksSqlWarehouse(
  warehouses: readonly DatabricksSqlWarehouse[],
): DatabricksSqlWarehouse | undefined {
  return (
    warehouses.find((warehouse) => warehouse.state?.toUpperCase() === "RUNNING") ?? warehouses[0]
  );
}
